import { graphql } from "./generated/index.js"

// Operations on the record_times table linking records to time spans.

// Queries ======================================================================

// Mutations ====================================================================

// Pass only the fields to update in _set.
export const updateRecordTime = graphql(`
  mutation updateRecordTime($id: Int!, $_set: record_times_set_input!) {
    update_record_times_by_pk(pk_columns: { id: $id }, _set: $_set) {
      ...RecordTimeFields
    }
  }
`)

export const updateManyRecordTimes = graphql(`
  mutation updateManyRecordTimes($updates: [record_times_updates!]!) {
    update_record_times_many(updates: $updates) {
      affected_rows
      returning {
        ...RecordTimeFields
      }
    }
  }
`)

export const createManyRecordTimes = graphql(`
  mutation createManyRecordTimes($objects: [record_times_insert_input!]!) {
    insert_record_times(objects: $objects) {
      returning {
        ...RecordTimeFields
      }
    }
  }
`)

export const deleteManyRecordTimes = graphql(`
  mutation deleteManyRecordTimes($ids: [Int!]!) {
    delete_record_times(where: { id: { _in: $ids } }) {
      affected_rows
      returning {
        id
      }
    }
  }
`)

// Closes a field's open span and opens the next one in one transaction, so a
// record never holds two open spans for a field. `objects` is empty when the
// value was cleared (a deal removed from its stage).
export const stampRecordSpan = graphql(`
  mutation stampRecordSpan(
    $recordId: Int!
    $schemaKey: String!
    $at: timestamptz!
    $objects: [record_times_insert_input!]!
  ) {
    update_record_times(
      where: {
        record_id: { _eq: $recordId }
        schema_key: { _eq: $schemaKey }
        end_at: { _is_null: true }
      }
      _set: { end_at: $at }
    ) {
      affected_rows
    }
    insert_record_times(objects: $objects) {
      returning {
        ...RecordTimeFields
      }
    }
  }
`)
